import { render, staticRenderFns } from "./ScenarioAnalysis.vue?vue&type=template&id=150b4bb1&scoped=true"
import script from "./ScenarioAnalysis.vue?vue&type=script&lang=ts"
export * from "./ScenarioAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./ScenarioAnalysis.vue?vue&type=style&index=0&id=150b4bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b4bb1",
  null
  
)

export default component.exports